<template>
  <v-flex
    id="additionalNotes"
    class="question"
  >
    <h2 class="header">
      {{ $t('warehouses.additional_notes.title') }} {{ $t('message.optional') | brackets }}
    </h2>
    <v-textarea
      v-model="additionalNote"
      v-validate="validationRules.get('long_regular_field')"
      :placeholder="$t('sheet.enter_text')"
      :error-messages="errors.collect('additionalNote')"
      :data-vv-as="' '"
      data-vv-name="additionalNote"
      auto-grow
      :disabled="readOnly"
      @blur="emitNotes()"
    />
    <v-divider class="my-4" />
  </v-flex>
</template>

<script>
import filters from '@/constants/filters';
import validationRules from '@/constants/validationRules';

import { mapFields } from 'vuex-map-fields';

export default {
    name: 'AdditionalNotes',
    inject: ['$validator'],
    props: {
        readOnly: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            validationRules
        };
    },
    computed: {
        ...mapFields('warehouses', ['additionalNote'])
    },
    filters: {
        ...filters
    },
    methods: {
        emitNotes () {
            this.$emit('emitNotes', this.additionalNote);
        }
    }
};
</script>

<style scoped></style>
